import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 18,
	viewBox: "0 0 10 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.703125 0.407227C0.78125 0.329102 0.859375 0.290039 1.01562 0.290039C1.13281 0.290039 1.25 0.329102 1.32812 0.407227L9.60938 8.68848C9.6875 8.7666 9.72656 8.88379 9.72656 9.00098C9.72656 9.15723 9.6875 9.23535 9.60938 9.31348L1.32812 17.5947C1.25 17.6729 1.13281 17.7119 1.01562 17.7119C0.859375 17.7119 0.78125 17.6729 0.703125 17.5947L0.390625 17.2822C0.3125 17.2041 0.273438 17.126 0.273438 16.9697C0.273438 16.8525 0.3125 16.7354 0.390625 16.6182L8.04688 9.00098L0.390625 1.38379C0.3125 1.30566 0.273438 1.18848 0.273438 1.03223C0.273438 0.915039 0.3125 0.797852 0.390625 0.719727L0.703125 0.407227Z",
		fill: "currentColor"
	})
});
export default SvgChevronRight;
